import { observer } from 'mobx-react';
import React from 'react';
import { useSlate } from 'slate-react';
import { RichTextBoxEditor, RichTextBoxToolbarButtonBaseProps } from '../richTextEditorTypes';
import { RichTextBoxToolbarButton } from './RichTextBoxToolbarButton';

type RichTextBoxIndentButtonProps = {
    decrease?: boolean
} & RichTextBoxToolbarButtonBaseProps

//Button didn't exist, was hardcoded in RichTextBox, moved it here to clean up RichTextBox Clutter.
export const RichTextBoxIndentButton = observer(({ decrease, ...props }: RichTextBoxIndentButtonProps) => {
    const editor = useSlate();
    const { attrs, ...trimmedProps } = props;
    const { onClick, ...trimmedAttrs } = attrs ?? { onClick: undefined };
    return (
        <RichTextBoxToolbarButton {...trimmedProps} {...{ isActive: false }} attrs={{
            onClick: (event) => {
                editor.changeBlockIndent(decrease);
                RichTextBoxEditor.focus(editor);
                if (onClick)
                    onClick(event);
            }, ...trimmedAttrs
        }} />
    )
});
